import { FC, useEffect, useRef } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import { AuditLogPage } from './AuditLogPage'

const AuditLogWrapper: FC = () => {
  const { config, setLayout } = useLayout()
  const restoreRef = useRef(config)

  useEffect(() => {
    restoreRef.current = config
    setLayout({
      ...config,
      header: { ...config.header, display: true },
      aside: { ...config.aside, display: true },
      toolbar: { ...config.toolbar, display: false },
      footer: { ...config.footer, display: true },
    })
    return () => setLayout(restoreRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <AuditLogPage />
}

export { AuditLogWrapper }
